import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class appSettingService {

  constructor() { }

  private applicationDetails = new BehaviorSubject<APPDETAILS>({
    "application_id": "",
    "project_id": "",
    "application_name": "",
    "application_type_id": "",
    "application_description": "",
    "logo": "",
    "theme_id": "",
    "s3_url": null,
    "is_published": false,
    "publish_status": "",
    "flutter_config": null,
    "biometric": null,
    "created_by": "",
    "created_date": "",
    "last_modified_by": "",
    "last_modified_date": "",
    "image": "",
    "transform_json": null,
    "published_json": null,
    "playstore_certificate_json": null
});

  applicationDetails$: Observable<APPDETAILS> = this.applicationDetails.asObservable();

  setApplicationDetails(appData:APPDETAILS) {
    this.applicationDetails.next(appData);
  }
  getApplicationDetails(){
    return this.applicationDetails.value;
  }

}

export interface APPDETAILS {
    application_description: string;
    application_id: string;
    application_name: string;
    application_type_id: string;
    biometric: any;
    created_by: string;
    created_date: string;
    flutter_config: any;
    image: string;
    is_published: boolean;
    last_modified_by: string;
    last_modified_date: string;
    logo: string;
    playstore_certificate_json: any;
    project_id: string;
    publish_status: string;
    published_json: any;
    s3_url: any;
    theme_id: string;
    transform_json: any;
  }